import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconWebsolute = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" stroke="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-websolute" data-icon="icon-websolute" aria-hidden="true" {...props} ref={ref}><path d="M12,0.1C5.4,0.1,0.1,5.4,0.1,12c0,6.6,5.3,11.9,11.9,11.9c6.6,0,11.9-5.3,11.9-11.9C23.9,5.4,18.6,0.1,12,0.1z M18.9,12.5
	c0,1-0.4,1.9-1.2,2.7c-0.8,0.8-1.7,1.1-2.8,1.1c-1.1,0-2.1-0.4-2.8-1.1v0l0,0c-0.8,0.8-1.7,1.1-2.8,1.1c-1.1,0-2.1-0.4-2.8-1.1
	c-0.8-0.8-1.2-1.7-1.2-2.7V8.6h2.3v3.9c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.5,1.2,0.5c0.5,0,0.9-0.2,1.2-0.5
	c0.3-0.3,0.5-0.7,0.5-1.2V8.7h2.3v3.8c0,0.5,0.2,0.9,0.5,1.1c0.2,0.2,0.3,0.3,0.6,0.4c0.2,0.1,0.4,0.1,0.7,0.1c0.2,0,0.5,0,0.7-0.1
	c0.2-0.1,0.4-0.2,0.6-0.4c0.3-0.3,0.5-0.7,0.5-1.1V8.6H19L18.9,12.5z"/></svg>);
});

IconWebsolute.displayName = 'IconWebsolute';
